export interface Operation {
  name: string;
  label: string;
  needsComparativeValue?: boolean;
  comparativeValueType?:
    | "string"
    | "number"
    | "regex"
    | "date"
    | "variable"
    | "positive-integer";
}

const stringOperationsBase: Operation[] = [
  { name: "IS_EMPTY", label: "Está vacío" },
  { name: "IS_NOT_EMPTY", label: "No está vacío" },
  {
    name: "EQUALS",
    label: "Es igual a",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
  {
    name: "NOT_EQUALS",
    label: "No es igual a",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
];

const numberOperationsBase: Operation[] = [
  { name: "IS_EMPTY", label: "Está vacío" },
  { name: "IS_NOT_EMPTY", label: "No está vacío" },
  {
    name: "EQUALS",
    label: "Es igual a",
    needsComparativeValue: true,
    comparativeValueType: "number",
  },
  {
    name: "NOT_EQUALS",
    label: "No es igual a",
    needsComparativeValue: true,
    comparativeValueType: "number",
  },
  {
    name: "GREATER_THAN",
    label: "Es mayor a",
    needsComparativeValue: true,
    comparativeValueType: "number",
  },
  {
    name: "LESS_THAN",
    label: "Es menor a",
    needsComparativeValue: true,
    comparativeValueType: "number",
  },
  {
    name: "GREATER_THAN_OR_EQUAL",
    label: "Es mayor o igual a",
    needsComparativeValue: true,
    comparativeValueType: "number",
  },
  {
    name: "LESS_THAN_OR_EQUAL",
    label: "Es menor o igual a",
    needsComparativeValue: true,
    comparativeValueType: "number",
  },
];

const datetimeOperationsBase: Operation[] = [
  { name: "IS_EMPTY", label: "Está vacío" },
  { name: "IS_NOT_EMPTY", label: "No está vacío" },
  {
    name: "EQUALS",
    label: "Es igual a",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "NOT_EQUALS",
    label: "No es igual a",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "IS_AFTER",
    label: "Es despues de",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "IS_BEFORE",
    label: "Es antes de",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "IS_ON_OR_AFTER",
    label: "Es despues o igual a",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
  {
    name: "IS_ON_OR_BEFORE",
    label: "Es antes o igual a",
    needsComparativeValue: true,
    comparativeValueType: "date",
  },
];

const booleanOperationsBase: Operation[] = [
  { name: "IS_EMPTY", label: "Está vacío" },
  { name: "IS_NOT_EMPTY", label: "No está vacío" },
];

const identificationOperationsBase: Operation[] = [
  { name: "IS_EMPTY", label: "Está vacío" },
  { name: "IS_NOT_EMPTY", label: "No está vacío" },
  {
    name: "EQUALS",
    label: "Es igual a",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
  {
    name: "NOT_EQUALS",
    label: "No es igual a",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
];

const arrayOperationsBase: Operation[] = [
  { name: "IS_EMPTY", label: "Está vacío" },
  { name: "IS_NOT_EMPTY", label: "No está vacío" },
  {
    name: "CONTAINS",
    label: "Contiene",
    comparativeValueType: "string",
    needsComparativeValue: true,
  },
  {
    name: "NOT_CONTAINS",
    label: "No contiene",
    comparativeValueType: "string",
    needsComparativeValue: true,
  },
];

const emailOperationsBase: Operation[] = [
  { name: "IS_EMPTY", label: "Está vacío" },
  { name: "IS_NOT_EMPTY", label: "No está vacío" },
  {
    name: "EQUALS",
    label: "Es igual a",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
  {
    name: "NOT_EQUALS",
    label: "No es igual a",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
  {
    name: "STARTS_WITH",
    label: "Comienza con",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
  {
    name: "ENDS_WITH",
    label: "Termina con",
    needsComparativeValue: true,
    comparativeValueType: "string",
  },
];

const textOperations: Operation[] = stringOperationsBase.map((o) => ({ ...o }));
const textareaOperations: Operation[] = stringOperationsBase.map((o) => ({
  ...o,
}));
const numberOperations: Operation[] = numberOperationsBase.map((o) => ({
  ...o,
}));
const emailOperations: Operation[] = emailOperationsBase.map((o) => ({ ...o }));
const selectOperations: Operation[] = arrayOperationsBase.map((o) => ({
  ...o,
}));
const datetimeOperations: Operation[] = datetimeOperationsBase.map((o) => ({
  ...o,
}));
const datetimeRangeOperations: Operation[] = datetimeOperationsBase.map(
  (o) => ({
    ...o,
  }),
);
const phoneOperations: Operation[] = stringOperationsBase.map((o) => ({
  ...o,
}));
const identificationOperations: Operation[] = identificationOperationsBase.map(
  (o) => ({ ...o }),
);
const fileOperations: Operation[] = booleanOperationsBase.map((o) => ({
  ...o,
}));

const switchOperationsBase: Operation[] = [
  { name: "IS_TRUE", label: "Es verdadero" },
  { name: "IS_FALSE", label: "Es falso" },
];

export const Operations = {
  text: textOperations,
  textarea: textareaOperations,
  number: numberOperations,
  email: emailOperations,
  select: selectOperations,
  date: datetimeOperations,
  datetime: datetimeOperations,
  datetime_range: datetimeRangeOperations,
  date_range: datetimeRangeOperations,
  phone: phoneOperations,
  identification: identificationOperations,
  file: fileOperations,
  interoperability: [],
  switch: switchOperationsBase,
};
